import { RaiseCard } from "../raise-components"
import styled from "styled-components"

import { WIDTH_BREAKPOINTS } from "../components/globalStyles"

export const Card = styled(RaiseCard)`
  .ant-card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: space-between;
  }
  margin-bottom: 20px;
`

export const SliderContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 27px;
`

export const ColLeft = styled.div`
  grid-area: left;
  display: flex;
  flex-direction: column;
`

export const ColRight = styled.div`
  grid-area: right;
  display: flex;
  flex-direction: column;
`

export const NotActiveCard = styled(RaiseCard)`
  .ant-card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: space-between;
    align-items: center;
    justify-content: center;
  }
  margin-bottom: 20px;
  height: 350px;
  @media only screen and (max-width: ${WIDTH_BREAKPOINTS.xl}) {
    height: 390px;
  }
  @media only screen and (max-width: ${WIDTH_BREAKPOINTS.sm}) {
    height: 400px;
  }
  @media only screen and (max-width: ${WIDTH_BREAKPOINTS.xs}) {
    height: 480px;
  }
`
